import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-DHAl7Frv.js';
import { o as observeCarouselVisibility } from './visibility-1aJUVV5h.js';

class FeaturedCollectionSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;
  /** @type {ReturnType<typeof observeCarouselVisibility> | null} */
  #visibility = null;

  connectedCallback() {
    this.#visibility = observeCarouselVisibility(this, {
      onEnter: () => {
        this.#embla = EmblaCarousel(this.querySelector('.embla__viewport'), {
          align: 'center',
          dragFree: true,
          slidesToScroll: 'auto',
          direction: document.dir,
          breakpoints: {
            '(min-width: 64rem)': { active: false },
          },
        });

        addScrollBarListener(this.#embla, this.querySelector('.embla__scrollbar'));
      },
      getEmbla: () => this.#embla,
    });
  }

  disconnectedCallback() {
    this.#visibility?.disconnect();
    this.#embla?.destroy();
    this.#embla = undefined;
  }
}

customElements.define('featured-collection-slider', FeaturedCollectionSlider);
